/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateGitlabVerificationKeyInput = {|
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createGitlabVerificationKeyMutationVariables = {|
  input: CreateGitlabVerificationKeyInput
|};
export type createGitlabVerificationKeyMutationResponse = {|
  +createGitlabVerificationKey: ?{|
    +key: ?string
  |}
|};
export type createGitlabVerificationKeyMutation = {|
  variables: createGitlabVerificationKeyMutationVariables,
  response: createGitlabVerificationKeyMutationResponse,
|};
*/


/*
mutation createGitlabVerificationKeyMutation(
  $input: CreateGitlabVerificationKeyInput!
) {
  createGitlabVerificationKey(input: $input) {
    key
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateGitlabVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateGitlabVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createGitlabVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createGitlabVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createGitlabVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createGitlabVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createGitlabVerificationKeyMutation(\n  $input: CreateGitlabVerificationKeyInput!\n) {\n  createGitlabVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd846396c2ae25166f3f78f9801c7344f';

module.exports = node;
